import { render } from "./ComplementaryData.vue?vue&type=template&id=f239e5ca"
import script from "./ComplementaryData.vue?vue&type=script&lang=js"
export * from "./ComplementaryData.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__